import { Button, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(true);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowInstallButton(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
        setShowInstallButton(false);
      });
    }
  };

  return (
    showInstallButton && (
      <div
        style={{
          position: "fixed",
          top: 20,
          // right: 20,
          margin: "0 auto",
          backgroundColor: "#fff",
          padding: "10px 20px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          display: "flex",
          alignItems: "baseline",
          gap: "10px",
        }}
      >
        <Typography variant="p" color="success">
          Install our app for better experience!
        </Typography>
        <Button
          onClick={handleInstallClick}
          variant="outlined"
          color="success"
          size="small"
        >
          Install
        </Button>
      </div>
    )
  );
};

export default InstallPWA;
